import { usePageHeader } from "@hooks/use_page_header";
import { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { BiLogoWhatsapp } from "react-icons/bi";
import { LuHash, LuMapPin, LuUser } from "react-icons/lu";
import { useMutation } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { useStudentBiography } from "@hooks/use_student_biography";
import { ProfileAvatarHeader } from "@components/general/profile_avatar_header";
import { Spiner } from "@components/loaders/spiner";
import { NoticeType } from "antd/es/message/interface";

export const SettingUpdateAccountPage = () => {
  usePageHeader("Edit Profil", { bottomNavigation: "hidden" });
  const [messageApi, contextHolder] = message.useMessage();
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [showMessageText, setShowMessageText] = useState<string>("");
  const [messageType, setMessageType] = useState<string>("");

  const { biography, isPending, gender, refetch } = useStudentBiography();

  const { mutate: onUpdateBio, isPending: isPendingUpdateBio } = useMutation({
    mutationFn: SchoolService.updateStudentBiography,
    onSuccess: (response) => {
      setShowMessage(true);
      setMessageType("success");
      setShowMessageText(response.message);

      refetch();
    },
    onError: (error: any) => {
      setShowMessage(true);
      setMessageType("error");
      setShowMessageText(error.message ?? "Internal Error");
    },
  });

  useEffect(() => {
    if (showMessage) {
      messageApi.open({
        type: messageType as NoticeType,
        content: <>{showMessageText}</>,
      });
    }
    setShowMessage(false);
  }, [showMessage, showMessageText]);

  return (
    <>
      {contextHolder}
      <div className="tw-px-4 tw-pt-2 tw-pb-0">
        <Form
          className=""
          autoComplete="off"
          initialValues={{
            nis: biography?.nis,
            namasiswa: biography?.namasiswa ?? "---",
            telephon: biography?.telephon ?? "---",
            kelas: biography?.kelas ?? "---",
            alamat: biography?.alamat ?? "---",
            namaAyah: biography?.namaayah ?? "---",
            namaIbu: biography?.namaibu ?? "---",
          }}
          onFinish={(data) => onUpdateBio(data)}
        >
          <div className="tw-mb-4 tw-mt-12 tw-pt-14 tw-relative tw-text-center card-body">
            <ProfileAvatarHeader
              foto={biography?.foto}
              namasiswa={biography?.namasiswa}
              kelas={biography?.kelas}
              marhalah={biography?.marhalah}
              gender={gender}
              isPending={isPending}
            />

            <div className="tw-my-4 divider"></div>

            <div className="tw-mb-6 tw-text-accent-primary">
              {isPending ? (
                <div className="tw-p-8 tw-text-center">
                  <Spiner />
                </div>
              ) : (
                <>
                  <Form.Item label="NIS" name="nis" className="tw-mb-4">
                    <Input
                      suffix={
                        <LuHash
                          size={20}
                          className="tw-text-text-primary"
                        />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="NIS"
                      disabled={true}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Nama Lengkap"
                    name="namasiswa"
                    className="tw-mb-4"
                  >
                    <Input
                      suffix={
                        <LuUser size={20} className="tw-text-text-primary" />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="Nama Lengkap"
                      disabled={true}
                    />
                  </Form.Item>

                  <Form.Item
                    label="No. Telepon (WhatsApp)"
                    name="telephon"
                    className="tw-mb-4"
                  >
                    <Input
                      suffix={
                        <BiLogoWhatsapp
                          size={20}
                          className="tw-text-[#91C60B]"
                        />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="-----"
                    />
                  </Form.Item>

                  <Form.Item label="Alamat" name="alamat" className="tw-mb-4">
                    <Input
                      suffix={
                        <LuMapPin
                          size={20}
                          className="tw-text-text-primary"
                        />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="Alamat"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Nama Ayah"
                    name="namaAyah"
                    className="tw-mb-4"
                  >
                    <Input
                      suffix={
                        <LuUser size={20} className="tw-text-text-primary" />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="Nama Ayah"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Nama Ibu"
                    name="namaIbu"
                    className="tw-mb-4"
                  >
                    <Input
                      suffix={
                        <LuUser size={20} className="tw-text-text-primary" />
                      }
                      className="tw-border-background tw-shadow-none hover:tw-border-primary focus:tw-shadow-none tw-text-base"
                      placeholder="Nama Ibu"
                    />
                  </Form.Item>
                </>
              )}
            </div>
          </div>

          <Button
            type="primary"
            htmlType="submit"
            loading={isPendingUpdateBio}
            className="tw-h-11 tw-w-full tw-text-sm tw-font-semibold tw-rounded-xl tw-border-0 tw-text-white focus:tw-shadow-none"
            style={{ background: "#166534" }}
          >
            Simpan
          </Button>
        </Form>
      </div>
    </>
  );
};
